<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseBubble from './Base.vue';
import Icon from 'next/icon/Icon.vue';
import { useMessageContext } from '../provider.js';

defineProps({
  icon: { type: [String, Object], required: true },
  iconBgColor: { type: String, default: 'bg-n-alpha-3' },
  senderTranslationKey: { type: String, required: true },
  content: { type: String, required: true },
  caption: { type: String, default: '' },
  title: { type: String, default: '' }, // Title can be any name, description, etc
  action: {
    type: Object,
    required: true,
    validator: action => {
      return action.label && (action.href || action.onClick);
    },
  },
});

const { sender } = useMessageContext();
const { t } = useI18n();

const senderName = computed(() => {
  return sender?.value?.name || '';
});
</script>

<template>
  <BaseBubble
    class="w-[min(19rem,calc(100vw-3rem))] overflow-hidden px-3 py-2.5"
    data-bubble-name="attachment"
  >
    <div class="flex min-w-0 flex-col gap-3">
      <div class="flex min-w-0 items-center gap-3">
        <div
          class="grid size-10 shrink-0 place-content-center rounded-full"
          :class="iconBgColor"
        >
          <slot name="icon">
            <Icon :icon="icon" class="size-5 text-white" />
          </slot>
        </div>
        <div class="min-w-0 flex-1 space-y-0.5 overflow-hidden">
          <slot>
            <div v-if="title" class="truncate text-sm font-medium text-n-slate-12">
              {{ title }}
            </div>
            <div v-if="content" class="truncate text-[13px] text-n-slate-11">
              {{ content }}
            </div>
            <div
              v-if="caption"
              class="text-sm text-n-slate-12 whitespace-pre-wrap"
            >
              {{ caption }}
            </div>
          </slot>
        </div>
      </div>
      <div v-if="action" class="-mx-3 -mb-2.5 border-t border-n-weak">
        <a
          v-if="action.href"
          :href="action.href"
          rel="noreferrer noopener nofollow"
          target="_blank"
          class="block h-11 w-full px-4 text-center text-sm font-medium leading-[2.75rem] text-[#00a884] transition-colors hover:bg-n-alpha-1"
        >
          {{ action.label }}
        </a>
        <button
          v-else
          class="h-11 w-full px-4 text-center text-sm font-medium text-[#00a884] transition-colors hover:bg-n-alpha-1"
          @click="action.onClick"
        >
          {{ action.label }}
        </button>
      </div>
    </div>
  </BaseBubble>
</template>
